import { render, staticRenderFns } from "./FinancePage.vue?vue&type=template&id=05d0c5d8&scoped=true&lang=pug&"
import script from "./FinancePage.vue?vue&type=script&lang=js&"
export * from "./FinancePage.vue?vue&type=script&lang=js&"
import style0 from "./FinancePage.vue?vue&type=style&index=0&id=05d0c5d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0c5d8",
  null
  
)

export default component.exports